export const SIDEBAR_LOCKED = 'SIDEBAR_LOCKED'
export const TRANSITION_TIMING = 'cubic-bezier(0.25, 0.1, 0.25, 1)'
